import React from 'react';
import useAddToCart from '@hooks/User/useAddToCart';
import classNames from 'classnames';
import cartButtonStyles
  from '@components/pages/ProductV2/shared/components/AddToCart/AddToCart.module.scss';
import Counter from '@components/shared/Counter/Counter';
import AddToCart from '@components/pages/ProductV2/shared/components/AddToCart/AddToCart';
import { useTheme } from '@components/theme';
import { IVendorVariantInternal } from '@models/VendorVariant/i-vendor-variant';
import { IVendorProductGroupingVendorVariant } from '@components/pages/ProductV3/shared/types';
import PriceVerificationGuarantee from '@components/pages/ProductV2/shared/components/PriceMatchGuarantee/PriceVerificationGuarantee';
import styles from './useAddToCartActions.module.scss';

export default function useCartActions(
  vendorVariant: IVendorVariantInternal | IVendorProductGroupingVendorVariant,
  boardId: string | undefined,
  isDisabled: boolean = false,
  onAddToCartClick: (value: boolean) => void
) {
  const theme = useTheme();

  const [
    addToCart,
    {
      busy: addingToCart,
      buttonLabel,
      quantity,
      setQuantity,
      error: addToCartError,
      isDoneAddingToCart,
    },
  ] = useAddToCart({ location: 'full_pdp', vendorVariant });

  const doAddToCart = () => {
    onAddToCartClick(true);
    addToCart({ boardId });
  };

  const getCartActionsComponent = (isFixed:boolean = false, showPriceMatch:boolean = false) => {
    return (
      <div
        className={classNames({
          [styles.FixedCartContainer]: isFixed
        })}
      >
        <div className={classNames(cartButtonStyles.AddToCart, styles.CartActions)}>
          <Counter
            min={1}
            onCountChange={setQuantity}
            count={quantity}
          />
          <AddToCart
            handleAddToCart={doAddToCart}
            buttonLabel={buttonLabel}
            isDisabled={addingToCart || isDisabled}
            className={classNames(
              cartButtonStyles.AddToCartButton,
              theme.styles.Button,
              theme.styles.Primary
            )}
          />
        </div>
        {showPriceMatch && (
          <PriceVerificationGuarantee className={styles.PriceMatch} />
        )}
      </div>
    );
  };

  return {
    getCartActionsComponent,
    addingToCart,
    addToCartError,
    isDoneAddingToCart,
    quantity
  };
}
